export const SET_APP_LOADING = 'SET_APP_LOADING';
export const SET_APP_COVER_LOADING = 'SET_APP_COVER_LOADING';
export const SET_APP_COVER_SECOND_LOADING = 'SET_APP_COVER_SECOND_LOADING';
export const SET_APP_ERROR = 'SET_APP_ERROR';
export const SET_USER_DATA = 'SET_USER_DATA';
